import { z } from 'zod';
import { syncBookkeepingSchema, uuidSchema } from './base.js';

export const sectionSchema = syncBookkeepingSchema.extend({
  id: uuidSchema,
  project_id: uuidSchema,
  name: z.string().min(1).max(200),
  sort_key: z.string().min(1),
});

export type Section = z.infer<typeof sectionSchema>;

export const sectionCreateSchema = sectionSchema.pick({
  id: true,
  project_id: true,
  name: true,
  sort_key: true,
});

export const sectionPatchSchema = sectionSchema
  .pick({ name: true, sort_key: true, project_id: true })
  .partial();

export type SectionCreate = z.infer<typeof sectionCreateSchema>;
export type SectionPatch = z.infer<typeof sectionPatchSchema>;
